import { useEffect, useState } from "react";
import "./style.scss"
import { substringFun, gclid } from "../../../utils/data/index.js";
const Singapore = () => {
    let isTrue = false;
    const [gclId, setGclId] = useState('');
    useEffect(() => {
        const fullUrl = window?.location?.href;
        setGclId(substringFun(fullUrl));
        if (isTrue === false) {
            isTrue = true;
            // const scriptDiv1 = document.createElement('script');
            // scriptDiv1.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            // new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            // j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            // 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            // })(window,document,'script','dataLayer','GTM-MH29QND');`;
            // document.head.appendChild(scriptDiv1);
            // const noscriptDiv = document.createElement('noscript');
            // noscriptDiv.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MH29QND"
            // height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
            // document.body.appendChild(noscriptDiv)
        }
        document.title = 'Singapore Online 1v1 Chinese Language Tuition - Sinobus';
    }, [])
    const gtag_report_conversion = () => {
        window.open('https://wa.me/8618244943229?text=Know%20more%20about%20Chinese%20online%20course', "_blank");
    }
    return <div className="tiktok">
        <img className="imgDf" src="../assets/singapore/SGTT.jpg" alt="" onClick={() => { gtag_report_conversion() }} />
    </div>
}
export default Singapore;